var render = function render(){var _vm=this,_c=_vm._self._c;return _c('playlist',{attrs:{"is-private":false,"playlist-id":_vm.$route.params.playlistId}})
}
var staticRenderFns = []

export { render, staticRenderFns }